import { gql } from '@apollo/client';


export const GET_TRANSLATION_AI_USAGE_DAILIES = gql`
    query GetTranslationAiUsageDailies(
        $text: String,
        $where: QueryTranslateAiUsageDailiesWhereWhereConditions,
        $orderBy: [QueryTranslateAiUsageDailiesOrderByOrderByClause!],
        $first: Int,
        $page: Int
    ) {
        translateAiUsageDailies(
            text: $text,
            where: $where,
            orderBy: $orderBy,
            first: $first,
            page: $page
        ) {
            paginatorInfo {
                total
                count
                currentPage
                perPage
                lastPage
            }
            data {
                id
                date_at
                requests_count
                items_count
                cache_hit_items_count
                prompt_tokens
                prompt_tokens_price
                completion_tokens
                completion_tokens_price
                total_tokens
                total_tokens_price
                created_at
                updated_at
            }
        }
    }
`;

export const GET_TRANSLATION_AI_REQUESTS = gql`
    query GetTranslationAiRequests(
        $text: String,
        $where: QueryTranslateAiRequestsWhereWhereConditions,
        $orderBy: [QueryTranslateAiRequestsOrderByOrderByClause!],
        $first: Int,
        $page: Int
    ) {
        translateAiRequests(
            text: $text,
            where: $where,
            orderBy: $orderBy,
            first: $first,
            page: $page
        ) {
            paginatorInfo {
                total
                count
                currentPage
                perPage
                lastPage
            }
            data {
                id
                model
                prompt_type
                source
                lang_source
                lang_target
                items_count
                cache_hit_items_count
                prompt_tokens
                prompt_tokens_price
                completion_tokens
                completion_tokens_price
                total_tokens
                total_tokens_price
                user_id
                created_at
                updated_at
                relUser {
                    id
                    name
                    surname
                    email
                }
            }
        }
    }
`;

export const GET_TRANSLATION_AI_LABEL_REQUESTS = gql`
    query GetTranslationAiLabelRequests(
        $where: QueryTranslateAiRequestsWhereWhereConditions,
        $orderBy: [QueryTranslateAiRequestsOrderByOrderByClause!],
        $first: Int,
        $page: Int
    ) {
        translateAiRequests(
            where: $where,
            orderBy: $orderBy,
            first: $first,
            page: $page
        ) {
            data {
                id
                model
                prompt_type
                lang_target
                items_count
                cache_hit_items_count
                prompt_tokens
                completion_tokens
                total_tokens
                total_tokens_price
                created_at
            }
        }
    }
`;

export const GET_TRANSLATION_AI_USAGE_DAILY_TOTAL = gql`
    query GetTranslationAiUsageDailyTotal {
        translateAiUsageDailyTotal {
            requests_count
            items_count
            cache_hit_items_count
            prompt_tokens
            prompt_tokens_price
            completion_tokens
            completion_tokens_price
            total_tokens
            total_tokens_price
        }
    }
`;
